module.exports = __webpack_public_path__ + "img/beer_id-1.898326d7.png";